import { render, staticRenderFns } from "./OverdueTasksManager.vue?vue&type=template&id=0bbac333"
import script from "./OverdueTasksManager.vue?vue&type=script&lang=js"
export * from "./OverdueTasksManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports